import React from 'react';
import { Link } from 'react-router';
import EmptyState from '../components/EmptyState';
import { lscPath } from '../routing';
import { useLscContentColumn } from '../lscContentColumn';

const LscNotFoundPage: React.FC = () => {
  useLscContentColumn('narrow');
  return (
  <div data-testid="lsc-not-found-page">
    <EmptyState
      title="Stream Center page not found"
      message="This league page does not exist or the link may be outdated."
      action={
        <div className="flex flex-wrap justify-center gap-3">
          <Link to={lscPath('/leagues')} className="btn-primary">
            Back to my leagues
          </Link>
          <Link to={lscPath('/')} className="btn-secondary">
            Go to Stream Center home
          </Link>
        </div>
      }
    />
  </div>
  );
};

export default LscNotFoundPage;
